<template>
  <div class="player" :style="playerStyle" @click="$emit('click')">
    <jersey-icon
      type="plain"
      :primary-color="primaryColor"
      :secondary-color="secondaryColor"
    />
    <div class="dorsal">
      {{ player.dorsal || '--' }}
    </div>
    <div class="name-container">
      <span class="name">{{ player.userLastname || player.position }}</span>
    </div>
  </div>
</template>
<script>
import JerseyIcon from './JerseyIcon'
export default {
  name: 'Player',
  components: { JerseyIcon },
  props: {
    player: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    primaryColor: {
      type: String,
      required: false,
      default: '#00A82D',
    },
    secondaryColor: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
    baseWidth: {
      type: Number,
      required: false,
      default: 480,
    },
  },

  computed: {
    playerStyle() {
      let size = (this.baseWidth / 480) * 48
      return `transform: translate(${this.player.location});
       width: ${size}px;
       height: ${size}px;`
    },
    dorsalStyle() {
      let size = (this.baseWidth / 480) * 48
      return `transform: translate(${this.player.location});
       width: ${size}px;
       height: ${size}px;`
    },
  },
}
</script>
<style lang="scss">
.player {
  cursor: pointer;
  position: absolute;
  touch-action: none;
  opacity: 1;
  display: block;
  border: inherit;
  background: initial;
  .dorsal {
    top: 13px;
    font-size: 15px;
    position: absolute;
    text-align: center;
    width: 100%;
    color: #fff;
    font-weight: 700;
    color: rgb(255, 255, 255);
    text-shadow: rgb(0, 0, 0) 1px 1px 1px;
    font-size: 16px;
    @media screen and (max-width: 600px) {
      font-size: 11px;
      top: 11px;
    }
  }
  .name-container {
    position: relative;
    text-align: center;
    .name {
      width: 132px;
      height: 15px;
      position: relative;
      background: transparent;
      font-weight: 700;
      color: #fff;
      border: none;
      font-size: 0.8rem;
      top: -5px;
      text-shadow: 1px 1px 1px #000;
      text-align: center;
      letter-spacing: 0.2px;

      @media screen and (max-width: 600px) {
        top: -5px;
        font-size: 11px;
        opacity: 1;
        width: 86px;
        // left: -22px;
        // position: absolute;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
      }
    }
  }
}
</style>
